import React from "react";
import { useApp } from "../contexts/AppContext";

const LegalPage = ({ kind = "privacy" }) => {
    const { t } = useApp();
    const title = kind === "privacy" ? t.footer.privacy : t.footer.terms;
    return (
        <div data-testid={`page-${kind}`} className="container-x section-pad max-w-3xl">
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
            <div className="mt-6 prose prose-slate dark:prose-invert max-w-none">
                {kind === "privacy" ? (
                    <>
                        <p className="text-muted-foreground">Effective date: {new Date().toLocaleDateString()}</p>
                        <p>Sri Matha Multiservices ("we", "our") respects your privacy. This policy explains how we collect, use, and protect the information you share when using srimathamultiservices.com.</p>
                        <h3>Information we collect</h3>
                        <ul>
                            <li>Contact details (name, email, phone, address) you submit through booking or contact forms.</li>
                            <li>Uploaded documents required to process government/digital service requests.</li>
                            <li>Basic usage analytics (never personal identifiers) to improve the site.</li>
                        </ul>
                        <h3>How we use it</h3>
                        <p>Only to fulfil the requested service, communicate progress, and comply with legal requirements.</p>
                        <h3>Security</h3>
                        <p>Uploaded documents are stored securely and shared only with authorized government portals as required to process your application.</p>
                        <h3>Contact</h3>
                        <p>For any privacy-related queries, write to srimatha.multiservices@gmail.com.</p>
                    </>
                ) : (
                    <>
                        <p className="text-muted-foreground">Effective date: {new Date().toLocaleDateString()}</p>
                        <h3>Service</h3>
                        <p>We act as an authorized intermediary to facilitate government (MeeSeva) and digital services. Final approval of any application rests with the respective government authority.</p>
                        <h3>Fees</h3>
                        <p>Service fees are payable as displayed at our center or online. Government-mandated fees are additional and non-refundable once submitted.</p>
                        <h3>Turnaround</h3>
                        <p>Turnaround time depends on the concerned government department. We provide best-effort estimates only.</p>
                        <h3>User obligations</h3>
                        <p>Users must provide accurate details and valid documents. Any fraudulent submission is the user's sole responsibility.</p>
                        <h3>Contact</h3>
                        <p>+91 9000767404 | srimatha.multiservices@gmail.com</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default LegalPage;
